<script>
import codeTable from '@/components/table';
import edit from './codeEdit';
import topBar from './topbar';
import columnsConfig from '@/modules/config/columns';
import {mapActions, mapGetters} from 'vuex';
export default {
	created() {
        this.setProvince();
		this.handleGetCarouselList();
        this.promiseAll();
	},
	data() {
		return {
			searchOption: {
				data: [],
				pageQuery: {
					total: 0,
					pageSize: 20,
					currentPage: 1,
					pageSizeList: [20, 40, 60]
				},
				searchQuery: {
					// name: '',
					// status: '',
					// queryTimeBegin: '',
					// queryTimeEnd: ''
                    title: '',
                    provinceId: '',
                    cityId: '',
                    firstTradeId: '',
                    secondTradeId: '',
                    channelType: '',
					queryTimeBegin: '',
					queryTimeEnd: '',
				}
			},
			editOption: {
				type: 0, // 0新增， 1编辑
				width: '40%',
				title: '新增',
				dialog: false,
				row: {},
                options: {
                    firstTradeId: [],
                    secondTradeId: [],
                    provinceId: [],
				    cityId: [],
                }
			},
			selectOption: {
				// status: []
                provinceId: [],
				cityId: [],
                firstTradeId: [],
                secondTradeId: []
			}
		}
	},
	methods: {
        // 获取选择项
        promiseAll() {
            Promise.all([this.getTradeType()]).then(res => {
                this.selectOption.firstTradeId = res[0].data || [];
                this.selectOption.secondTradeId = res[0].data[0].childTrade;

                this.editOption.options.firstTradeId = res[0].data || [];
                this.editOption.options.secondTradeId = res[0].data[0].childTrade;
            });
        },
		// async getPhotoStatus() {
		// 	const {data} = await this.photoStatus();
		// 	this.selectOption.status = data || [];
		// },
		handleDelete(row){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delete(row);
            })
		},
        async delete(row) {
            const id = row.id;
			const {code} = await this.mallDelete({id});
			if (Object.is(code, 200)) {
				this.$message.success('删除成功');
				this.handleGetCarouselList();
			}
        },
		handleEdit(row, type, title) {
			this.editOption.type = type;
			this.editOption.title = title;
			this.editOption.row = row;
			this.editOption.dialog = true;

			this.$nextTick(()=> {
				this.$refs.edit.initQuery(row);
			});
            if(type === 1) {
                this.changeEdit({value: row.provinceId, type: 'provinceId'});
                this.changeEdit({value: row.firstTradeId, type: 'firstTradeId'});
            }
		},
		handleAdd() {
			this.handleEdit({}, 0, '新增');
		},
		async handleGetCarouselList() {
			this.$loading(true);
			const {searchQuery, pageQuery} = this.searchOption;
			const {pageSize, currentPage} = pageQuery;
			try {
				const {code, data} = await this.mallList({
					...searchQuery,pageSize, currentPage
				});
				this.searchOption.data = data.dataSource || [];
				this.searchOption.pageQuery.total = data.total;
			} catch (e) {
				throw e;
			} finally {
			    this.$loading(false);
			}
		},
		switchChange(status, id){
			this.updateStatus({id, status});
		},
        change({value, type}) {
			this.searchOption.pageQuery.currentPage = 1;
            if (type && Object.is(type, 'provinceId')) {
				this.searchOption.searchQuery.cityId = '';
				this.selectOption.cityId = this.setCity(value);
			}
             if (type && Object.is(type, 'firstTradeId')) {
				this.searchOption.searchQuery.secondTradeId = '';
				this.selectOption.secondTradeId = this.setTrade(value);
			}
		},
        setProvince() {
            const list = this.cityList.filter(item => item.parentId === 0);
            this.selectOption.provinceId = list;

            this.editOption.options.provinceId = list;
        },
        setCity(val) {
			return this.cityList.filter(item => item.parentId === val);
		},
        setTrade(val, options = this.selectOption) {
            const list = options.firstTradeId.filter(item => item.tradeId === val);
			return val ? list[0].childTrade : [];
		},

        changeEdit({value, type}) {
            const options = this.editOption.options;
            if (type && Object.is(type, 'provinceId')) {
				this.editOption.options.cityId = this.setCity(value);
			}
             if (type && Object.is(type, 'firstTradeId')) {
                this.editOption.options.secondTradeId = this.setTrade(value, options);
			}
		},
		...mapActions('zft',['mallList','mallAdd', 'mallEdit', 'mallDelete', 'getTradeType', 'updateStatus'])
	},
	computed: {
		columns() {
			return columnsConfig;
		},
        ...mapGetters('zft', ['cityList'])
	},
	components: {
		codeTable, topBar, edit
	},
    watch: {
		'cityList': function() {
			this.setProvince();
		}
	}
}
</script>
<template>
<div class="rule-list">
	<top-bar :handlerSearch="handleGetCarouselList"
	  :searchQuery="searchOption.searchQuery"
      :selectOption="selectOption"
	  @handleAdd="handleAdd"
      @change="change"
	></top-bar>
    <code-table
     :data="searchOption.data"
     :columns="columns.auditMallColumns"
     :searchEvent="handleGetCarouselList"
     :pageOptions="searchOption.pageQuery"
    >
        <el-table-column label="项目标题" align="center" slot="title" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
				<span class="active" @click="skipPage(scope.row)">{{scope.row.name}}</span>
	        </template>
        </el-table-column>
        <el-table-column label="头图" align="center" width="100" slot="img">
            <template slot-scope="scope" v-if="scope.row.imageUrl">
				<el-image :src="scope.row.imageUrl" style="width: 30px; height: 30px" :preview-src-list="[scope.row.imageUrl]"></el-image>
	        </template>
        </el-table-column>
		<el-table-column label="操作" align="center" width="160" slot="operate" fixed="right">
            <template slot-scope="scope">
	        	<el-button type="success" @click="handleEdit(scope.row, 1, '编辑')">编辑</el-button>
	        	<el-button type="success" @click="handleDelete(scope.row)">删除</el-button>
	        </template>
        </el-table-column>

    </code-table>
    <edit ref="edit"
	  :codeEvent="+editOption.type === 0 ? mallAdd : mallEdit"
	  :searchEvent="handleGetCarouselList"
	  :editOption="editOption"
      @changeEdit="changeEdit"
	></edit>
</div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
</style>
